export const COLLAPSE_RIGHT_PANE = 'COLLAPSE_RIGHT_PANE';
export const EXPAND_RIGHT_PANE = 'EXPAND_RIGHT_PANE';
export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const EXPAND_MENU = 'EXPAND_MENU';
export const LAYOUT_SETTING = 'LAYOUT_SETTING';



// WEBPACK FOOTER //
// ./app/modules/page-layout/store/action-types.js